import { render, staticRenderFns } from "./Estantes.vue?vue&type=template&id=5e11b38c&"
import script from "./Estantes.vue?vue&type=script&lang=js&"
export * from "./Estantes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports